import { getLocale } from "../runtime";

const sv_trackorderreferenceexample = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `T.ex. ia1120a8`
};

const trackorderreferenceexample = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_trackorderreferenceexample(inputs)
	return "trackOrderReferenceExample";
};

export { trackorderreferenceexample as "trackOrderReferenceExample" };